module.exports = __webpack_public_path__ + "static/media/flags_ARG.45eff005.svg";